module.exports = __webpack_public_path__ + "static/media/fan.969a0fb1.svg";